export default __webpack_public_path__ + "static/11-ba3361295011615d0637484ca7d7a4c9.png";